import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";

const useStyles = makeStyles(sectionTextStyle);

export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <Box 
        sx={{
          '& ol li': {
            fontSize: '1.188rem'
          }
        }}
      >
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>


          <Quote
            textClassName={classes.quoteText}
            text="“Reviews are the ultimate form of advertising”"
            author="Andrew Heinzman, How To Geek & Review Geek"
          />
          <br />

        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Fake Reviews</h3>
          <br />
          <p>
            Fake reviews... we all know they exist. We all know its a problem - but do we really understand its scale? Should we be worried about how much fake reviews are delegitimising the online econmomy? Fake google reviews, fake amazon reviews, fake whatever reviews... are they all as bad as each other??? Can fake reviews be spotted???? Read on for our indepth look.
          </p>
        </GridItem>
        
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Fake reviews on my ubud holiday...</h3>
          <p>
          Just recently, I was in Ubud, Bali. A week or so of yoga, sightseeing and rejuvenation… towards the end I had a couple of spare days and decided to buy a “nicer” hotel. Now everyone has their own preferred platform(s) for me it was booking.com. I’d used it before for business and had a business account set up. There's something about it that seems a little bit more “legitimate to me”. Maybe it's their appeal to business travellers.. anyway.
          </p>
          </GridItem>
          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos1-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>Ubud is amazing btw...</i> 😎🌋🗿</p>
            </GridItem>
          </div>
          <GridItem xs={12} sm={8} md={8}>
          <p>

            <br />
            On my selected dates in Ubud there were 1,320 properties found… which one to choose? It's a similar task we are faced with all the time on the internet: which similar product or services should I choose? Which “value model” should I construct in my mind?
            </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos2-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>I'll pick the er... Blue one??</i></p>
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>

          
            For me the formula went like this:
            <br></br><br></br>
            <strong> Accomodation Ranking = Price x Location (not in the center, not too far away) x Views x Photos x Reviews</strong>
            <br></br><br></br>
            So armed with this formula and 45mins by the pool - I found what looked a perfect fit... and just look at those wonderful reviews averaging at 4.7! (See below).
            </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos3-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>The perfect fit according to my formula! </i>😵</p>
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>      
            <br></br>
            <h3 className={classes.title}>Fake reviews: the probably too late "warning signs" for a hotel</h3>  
            <ol start="1">
              <li><strong>Opulent reception desk area. </strong>Ok... having a glittering, nice or "comfy" or whatever reception area is generally a good thing... but as we'll see here - if it's a little overdone, you might wanna be aware. Some places - this included - pour all their attention into making a lovely reception area - while the actual place and rooms are very sub-par. Having a live cultural band decked to the nines who sit there on repeat all day "churning" out the tunes is probably another indication of where the priorities are.</li>
              <li><strong>Expensive uniforms. </strong>So organisation is a good thing. Uniforms are good... but if you get a sense it's really in your face with the sheer volumes of decked out staff running around not doing much... I'd be wary. Keep an eye out for armies of staff...</li>
              <li><strong>A person for every minor task. </strong>If there are separate staff members to carry your luggage to the luggage cart and more staff to place it on the cart and then more staff to take it off the cart and then more staff to brush the path in front of the cart and then more staff to drive the cart and more staff to give directions to the cart... etc etc you get the idea. I get it poorer countries can hire more staff and people need a job. But for me this was a sign of people "just doing any kind of job" and none of them particularly well. Acceptable levels of staff doing a number of tasks efficiently... that's what you want!</li>
            </ol>
          </GridItem>

          <GridItem xs={12} sm={8} md={8}>      
            <br></br>
            <h3 className={classes.title}>"Premier suite - with a view" - The reality</h3>
                
            <ol start="1">
              <li>It had <strong>no view</strong> I repeat, the "room with a view" <strong>had no view.</strong> Instead a giant wall obscured everything - even sunlight.</li>
              <li>$190per night {"<-"} relatively expensive for a hotel room in bali</li>
              <li>Tiny, ugly square box/prison cell of a room</li>
              <li>Reeked of mould. The kind of sick damp smell of something that hasn't been used in a long time, fresh and professionally cleaned so that it's still damp and "pungent". It was a sickening smell</li>
              <li><strong>There was a different guest name on the key.. </strong>What does that actually mean - I'm in the wrong room? They have my room? Is this a dream..?</li>     
            </ol>
            <p>
              After complaining about all the above I was offered another equally bad room.. I couldn't believe it. All I wanted to do was leave and try and enjoy the last couple of days of my holiday in some place - any place - but this...

              So what went wrong??? "Everyone" in the reviews said this place was amazing...
          </p>
          </GridItem>

          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos5-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>Yeah it's Google reviews but still... </i>😵</p>
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>
          
          The major observation here - beside the huge 4.7 overall score - is the massive top-heaviness of these ratings... an absolute barrage of 5 star reviews, offset by very little else. Top this with the fact there had been 1308 reviews!!!!! That would have required almost 5 guests reviewing the hotel every single day for an entire year!
          <br></br><br></br>
          Below is a review from TripAdvisor for the same hotel - which is way more aligned with what I actually saw:
          </p>

        </GridItem>


        <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos4-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>A review from Trip Advisor that was a lot more aligned with my actual experiences!</i></p>
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>      
            <br></br>
            <h3 className={classes.title}>We are surrounded by fake reviews</h3>
            <p>
              We all know google reviews are easy to manipulate. Heres some reasons why:
            </p>
            <ol start="1">
              <li>Any person with a google account can write a review about any place on google maps!</li>
              <li>I personally have 20 google accounts to manage all our various business/client accounts - how many do you have?</li>
              <li>How many could you potentially have? {"<-"} I truly don't know the answer to this</li>
              <li>Have you ever filled out a fake review? Be honest here.</li>
              <li>Would you accept payment for a fake review?</li>
            </ol>
            <p>
              The last point is the disturbing point. People are receiving payment to write fake reviews. In fact this has become a growing and thriving "industry"!?! See the image below. Ads for these "services" are easily found on upwork and similar sites..
            </p>
          </GridItem>

          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos6-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>Mr Taylor Described himself as "cynical"...</i></p>
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Surely BOOKING.COM is fine though???</h3>
          <p>

          Surely Booking.com is "above" this right... you have to stay there to write a review right...???
          <br></br><br></br>
          Yea Nah.
          <br></br><br></br>
          <strong>There's a nice little (actually massive) scam going on where hotel owners “pay people” to make a booking at their own property and give a positive review… </strong>the money from the "booking" of course comes back to the hotel. Some other benefit is worked out on the side with the reviewer.
          <br></br><br></br>
          Another "cool" thing with booking.com is that if you cancel your booking mid-stay - you can't leave a review. Which is what happened in my case. This clearly artificially inflates ratings.
                      </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos16-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>Lord Saruman overseeing his army of fake reviewers...</i></p>
            </GridItem>
          </div>


          
          <br />
          <GridItem xs={12} sm={8} md={8}>
            <h3 className={classes.title}>Amazon..??? Heard of "brushing" yet?</h3>
            <p>Yeah they are all fake too. Althose product reviews you spend so much time sifting through, reading and comparing. You can easily tell the fake ones right? Well sometimes... but you can't read every single review on the internet!
            <br />
            <br />In Amazon-land- personal data used by sellers to gather fake "verified reviews"! This "practice" known as "brushing", sees sellers obtain people's name and address and then send them goods which they did not purchase - for the sole purpose of writing a favourable review of said product...
            <br /><br />
            Yep. Thats happening. And it's rife!
            <br />
            <br />In the following article from the BBC, Architect Paul Bailey, in Essex believes he may have been targeted. He received a number of unexpected "gifts", including a key-ring, a phone case, a tattoo removal kit and a charcoal toothpaste set.
            for more details check out here: <a href="https://www.bbc.com/news/uk-47952165" target="_blank">https://www.bbc.com/news/uk-47952165</a> 
            </p>
            <br />
          </GridItem>

          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>More Examples</h3>
          </GridItem>

          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos7-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>The infamous Red Hen incident where Sarah Sanders was refused service at a restaurant, which then received 100s of fake negative reviews on Yelp, Facebook, Google etc</i>
                    </p>
            </GridItem>
          </div>
          <br /><br />

          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos9-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>Reviews on owned domains have always been problematic.. even more so now that companies like Samsung are using tools called (no joke) "Bazaaar Voice".. that generate “user-generated content marketing”...</i>
                    </p>
            </GridItem>
          </div>
          
          
          <br />
          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>So What Can we do about it??</h3>
          <h4 className={classes.title}>Scrape Google Reviews using the Paces API - er yeah...</h4>

          <p>
          So yep - scrape all the reviews for a certain place or places and determine if you can see fraud somehow... sounds like an idea. EXCEPT!!! Google only lets you return 5 reviews from a place call! The last 5 reviews. WTAF? This issue is infuriating and has been an ongoing feature request since Feb 12, 2015 - with 371 users starring the issue and counting. See here for more: <a href="https://issuetracker.google.com/issues/35825957" target="_blank">https://issuetracker.google.com/issues/35825957</a>
          </p>

          <p>
          <strong>Other Scrapers</strong>
          <br />You can try APIFY... it's a pretty cool tool that allows you to create "apps or scrapers" that amongst other things can scrape google maps reviews. It works pretty good in our experience. Here's some more details.
          <br />* Scrapes actual Google Reviews. $49 per month minimum..
          <br />* Breaks Google's T{"&"}Cs (not allowed to scrape anything) but is offset by multiple proxy servers.
          <br />* Does Not capture all the fields the Google place API does.
          
          <br /><br />The biggest issue though is: <strong>even if you have all the reviews, how do you determine which ones are fake?</strong>
          </p>
          </GridItem>

          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos10-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>APIFY, this tool is pretty cool $49 a month.. yeah.. maybe you can get something happening? Need to determine if those reviews are fake or not first though..</i>
                    </p>
            </GridItem>
          </div>
          

          <br />
          
          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>FakeSpot</h3>
          <br /> This is an attempt to automagically tell you if a review is fake or not. Now this sounds great... Unfortunately, in our experience it's pretty inaccurate. Our anecdotal experience shows a 75% accuracy in detecting fake reviews. We did however pull out a good comparison for our real life horror scenario above. It classed the "terrible" hotel in our initial review as a "C - likely to be fake" as opposed to the smaller, much better place we actually went to that got an "A" grade.
          </GridItem>

          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos11-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>akespot is a great concept - but it's generally inaccurate. In some cases, like ours above - it is great though..</i>
                    </p>
            </GridItem>
          </div>
          
          
          <br />
          <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>How do you actually spot a fake reviews?</h3>
          <p>
          Well... the results aren't too promising... according to a study by Cornell University way back in 2011!!!:
          <br />1) Human judges no better than random chance in determining whether reviews are fake or not
          <br />2) Humans suffer from a "truth bias” - assuming that what they are reading is true until they find evidence to the contrary.
          <br />3) Truthful hotel reviews, use concrete words relating to the hotel, like "bathroom," "check-in" or "price." Deceivers write more about things that set the scene, like "vacation," "business trip" or "my husband."
          <br />4) This is imaginative vs. informative writing, deceivers use more verbs and truth-tellers use more nouns.
          <br />5) Deceivers include more first person pronouns. If you're anxious about coming across as sincere, you talk about yourself more. That's probably why words like 'I' and 'me' appear more often in fake reviews.
          <br />6)  Using these approaches, the researchers trained a computer on a subset… and achieved 89.8 percent accuracy.
          </p>
          </GridItem>

          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos12-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>Read more about this study <a href="https://news.cornell.edu/stories/2011/07/cornell-computers-spot-opinion-spam-online-reviews" target="_blank">here</a>.</i>
                    </p>
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <br />
          <p>
          Here we see an actual example taken from the Cornell study. It's interesting to see. Clearly the fake review is:
          <br />1. Longer
          <br />2. "Sets the scene" / is low on very specific details
          <br />3. Uses "I", "we" a lot...
          <br />
          </p>
          </GridItem>

          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos13-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>An example of a Real v Fake review taken from the Cornell Study.</i>
                    </p>
            </GridItem>
          </div>
          
          <GridItem xs={12} sm={8} md={8}>
          <p> Here are some links to the Cornell paper: <a href="https://myleott.com/op-spam.html" target="_blank">Link 1</a>, <a href="https://myleott.com/op_spamACL2011.pdf" target="_blank">Link2</a>
          </p>
          
          <br />

          <h3 className={classes.title}>The Main Takeouts:</h3>
          <p>
          <strong>1. You need to treat every review you read on the internet as potentially fake</strong>
          <br /> It doesn't matter the network, even supposed "closed loop" review sites like bookng.com or even Amazon - are easily and mercilessly circumvented by unscrupulous operators. Google reviews and Facebook are just a laughing stock - but they really aren't too much worse then the others.
          
          <br /><strong>2. Detecting Fake Reviews with a Model is inaccurate and a work in progress</strong>
          <br />* Detecting fake reviews from an algorithm is going to have inherent accuracy.
          <br />* Is this error acceptable - ie is it better than nothing?
          <br />* Cornell study was 89% accuracy. Fakespot seems to be ~75% accuracy.
          <br />* Reviewers (not all) will likely become more sophisticated over time.
          
          <br /><strong>3. Detecting Fake Review with a “Trust Network” is likely the best option</strong>
          <br />* More accurate
          <br />* Only rely on reviews from people you know/trust &lt;- social network
          <br />* Have a system/(maybe government agency) that you can trust for reviews.
          
          <br /><br /><strong>Aside:</strong> Why does Google make it basically impossible to download reviews data (unless from GMB). And why the same policy for scraping SERPs? These services are now so vital in how the internet and hence much of our society works - that unfortunately they now serve much more important roles than just the original one: ie to make Google money.
          </p>
          </GridItem>
          
          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-10-01-FakeReviews/baliphotos17-min-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
                    <p><br></br><i>Unleash the Fake Reviews</i>
                    </p>
            </GridItem>
          </div>
      
      </GridContainer>
      </Box>
    </div>

  );
}
